"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMedia = useMedia;
const react_1 = require("react");
const media_query_list_1 = require("../../helpers/media-query-list");
const use_isomorphic_layout_effect_1 = require("../use-isomorphic-layout-effect");
const context_1 = require("../../context");
/**
 * Возвращает состояние по media-запросу.
 * @param query Запрос.
 * @return Состояние (matches).
 */
function useMedia(query) {
    const [matches, setMatches] = (0, react_1.useState)(false);
    const { matchMedia } = (0, react_1.useContext)(context_1.MatchMediaContext);
    (0, use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect)(() => {
        const mql = matchMedia(query);
        setMatches(mql.matches);
        return (0, media_query_list_1.subscribe)(mql, event => {
            setMatches(event.matches);
        }).unsubscribe;
    }, [query, matchMedia]);
    return matches;
}
//# sourceMappingURL=index.js.map